// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import get from 'lodash/get'
import moment from 'moment'
import React from 'react'
import { Query } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import { getConnectionNodes, getConnectionTotal } from '../../common/data/helper'
import Pagination from '../../common/pagination/Pagination'
import RestrictedView from '../auth/RestrictedView'
import { i18n } from '../index'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import TaskListTable from './TaskListTable'
import { ASSIGNMENTS_QUERY } from './data'
import css from './taskListActive.css'
type Props = {
  history: any
  activeStation: Station
}
type State = {
  pageSize: number
  page: number
}

@withActiveStation
class TaskListActive extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      pageSize: 10,
      page: 1,
    }
  }

  onPageChange = (page) => {
    this.setState({
      page,
    })
  }
  onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize,
      page: 1,
    })
  }

  onItemSaved = async (refetch: any) => {
    // refetch
    await refetch()
  }

  render() {
    const fromDate = moment().subtract(30, 'days')
    const toDate = moment()
    const { page, pageSize } = this.state
    const { activeStation } = this.props
    // debugger
    return (
      <div className={css.component}>
        <Query
          query={ASSIGNMENTS_QUERY}
          fetchPolicy='network-only'
          variables={{
            stationId: activeStation.id,
            status: 'InProgress',
            perPage: 100,
          }}
        >
          {({ loading, error, data, refetch }) => {
            const items = loading ? [] : getConnectionNodes(get(data, 'assignments', []))
            return (
              <div className={css.activeTable}>
                <h3>
                  {i18n.t('taskList.active.activeTitle', {
                    station: activeStation.name,
                  })}
                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => this.props.history.push('/tehtavalista/uusi-tehtava')}
                  >
                    {i18n.t('taskList.newButtonText')}
                  </Button>
                </h3>
                <RestrictedView requiredPermission='edit_tasklist'>
                  {(hasPermission) => (
                    <TaskListTable onItemSaved={refetch} isLoading={loading} items={items} canEdit={hasPermission} />
                  )}
                </RestrictedView>
              </div>
            )
          }}
        </Query>
        <Query
          query={ASSIGNMENTS_QUERY}
          variables={{
            stationId: activeStation.id,
            status: 'Done',
            fromDate: fromDate.format('YYYY-MM-DD'),
            toDate: toDate.format('YYYY-MM-DD'),
            page: page,
            perPage: pageSize,
          }}
        >
          {({ loading, error, data }) => {
            const items = loading ? [] : getConnectionNodes(get(data, 'assignments', []))
            const total = loading ? 0 : getConnectionTotal(get(data, 'assignments', []))
            const paginationProps = {
              pageSize,
              page,
              total,
              onPageChange: this.onPageChange,
              onPageSizeChange: this.onPageSizeChange,
            }
            return (
              <div className={css.archivedTable}>
                <h3>
                  {i18n.t('taskList.active.archiveTitle', {
                    fromDate: fromDate.format('D.M.YYYY'),
                    toDate: toDate.format('D.M.YYYY'),
                  })}
                </h3>
                <Pagination {...paginationProps} />
                <TaskListTable items={items} isLoading={loading} />
                <Pagination {...paginationProps} hideLegend />
              </div>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default withRouter(TaskListActive)
